import React from "react"
import { Navigate, Outlet } from "react-router-dom"
import { useAuth } from "../context/auth"
export default function PrivateRoute() {
  const { isAuthenticated } = useAuth()
  if (!isAuthenticated) return <Navigate to="/" />
  return <Outlet />
}
